import Header from '../components/Header';
import Footer from '../components/footer';
import Spinner from 'react-bootstrap/Spinner';
import 'mdb-react-ui-kit';
import Video from '../components/video';




function App(props) {
  return (
    (<>
      <Header />
      <div className='container text-center' style={{ paddingTop: 40, paddingBottom: 50 }}>

        <Video  />
        
        <div className='quote-section' style={{ marginTop: 40 }}>
          <h1 className="sron">
            الخلود.. من بين بساطة اللفظ وعمق الدلالة..  فتهزنا من الأعماق.. لتتولد لغة عالمية أخرى غير الموسيقى.. لغة  في إطار.. الصورة الفوتوغرافية، فالخلود هو أبسط تعبير عن الفن الحقيقي قديما وحاضرا.. سواء في الهدف والغاية.. أو النتيجة المتوقعة لهذا الفن بمعناه الشامل.. "فالفن الحقيقي يمتلك القدرة على قهر الموت".
            وهنا نتحدث عن فن خالد 
             خلود البشرية.. من عصر  الحضارات الانسانية الأولى..الى عصر الصورة الرقمية اليوم.. ولا ندري ماذا يخبيء لنا المستقبل من الأسرار.
          </h1>
          <div align='left' style={{ marginTop: 24 }}>
            <div className='box-b'>
              <h4 style={{ margin: 0, fontWeight: 700, fontSize: '1.1rem' }}>
                أ.د/ إيمان زكي موسى الشريف
              </h4>
              <p style={{ margin: '4px 0 0', fontSize: '0.9rem', opacity: 0.9 }}>
                عميد كلية التربية النوعية - جامعة المنيا
              </p>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 40 }}>
          <a className='btn-cta' href='gallery' role='button'>
            عرض الصور
            <Spinner animation="grow" size='sm' />
          </a>
        </div>

      </div>
      <Footer />
    </>)

  );
}

export default App;